import { FC, useMemo } from 'react';
import Image from "next/legacy/image";
import { SxProps } from '@mui/material';
import ImageWrapper from './Image-wrapper';
import { InterestDto, InterestsEnum, showNativeAsset } from '@sweatpals/shared';
import { DEFAULT_INTEREST_IMAGE, INTERESTS, INTERESTS_IMAGES } from '../../constants/intersets';
import RemoteImage from './Remote-image';

export type FitnessIconType = {
	fitnessTypeId?: InterestsEnum | string;
	showNativeImage?: boolean;
	iconWidth?: number;
	iconHeight?: number;
	objectFit?: 'contain' | 'cover';
	sx?: SxProps;
};

const FitnessIcon: FC<FitnessIconType> = ({
	fitnessTypeId,
	iconWidth = 32,
	iconHeight = 32,
	sx,
	showNativeImage,
	objectFit,
}) => {
	const nativeImageExists = useMemo(() => !!INTERESTS_IMAGES[fitnessTypeId]?.image, [fitnessTypeId]);

	const src = INTERESTS_IMAGES[fitnessTypeId]?.image || DEFAULT_INTEREST_IMAGE;

	const alt = INTERESTS[fitnessTypeId]?.name ?? 'interest';

	const showStaticImage = useMemo(
		() =>
			showNativeAsset(
				{ id: fitnessTypeId, iconId: fitnessTypeId, hasPriorityOverNativeAsset: showNativeImage } as InterestDto,
				nativeImageExists
			),
		[fitnessTypeId, nativeImageExists, showNativeImage]
	);

	return showStaticImage ? (
		<ImageWrapper sx={{ width: `${iconWidth}px`, height: `${iconHeight}px`, ...sx }}>
			<Image
				layout="fill"
				src={{ src, width: iconWidth ?? 16, height: iconHeight ?? 16 }}
				objectFit={objectFit ?? src === DEFAULT_INTEREST_IMAGE ? 'contain' : 'cover'}
				alt={alt}
			/>
		</ImageWrapper>
	) : (
		<RemoteImage
			src={src}
			width={iconWidth ?? 16}
			height={iconHeight ?? 16}
			sx={{ width: `${iconWidth}px`, height: `${iconHeight}px`, ...sx }}
			alt={alt}
			objectFit={objectFit ?? src === DEFAULT_INTEREST_IMAGE ? 'contain' : 'cover'}
		/>
	);
};

export default FitnessIcon;
